import React from "react";
import Hero from "./hero";
import Footer from "../footerComponent/footer";
import '../../index.css';

function App() {
  return (
    <div>
      <Hero />
      <Footer />
    </div>
  );
}

export default App;